import axios from 'axios'

import { supabase } from 'clients/supabaseClient'
import { ShiftRow } from 'types/supabase.database.custom.types'
import { TA_DRAFT_PUBLIC_SHIFTS_API_PATH } from 'config/app.config'
import { getDraftBaseUrl } from 'utils/draftBase'

// TA Draft is where shift statuses (cancelled, delayed) are recorded: a local one in
// development if found, else the live site.  Supabase is only the fallback when it fails.
const getPublicShiftStatusUrl = async (): Promise<string> => {
  const configuredUrl = process.env.REACT_APP_PUBLIC_SHIFT_STATUS_API
  if (configuredUrl) return configuredUrl

  return `${await getDraftBaseUrl()}${TA_DRAFT_PUBLIC_SHIFTS_API_PATH}`
}

export const fetchShiftByEmailAndStartTime = async (
  email: string,
  startTimeUtcIso: string
): Promise<ShiftRow[]> => {
  try {
    const url = `${process.env.REACT_APP_SCANNER_API}/shifts/find/${email}/${startTimeUtcIso}`
    const response = await axios.get(url)
    return response.data
  } catch (error) {
    console.trace(error)
    throw new Error('fetchShiftByEmailAndStartTime failed.')
  }
}

export const fetchShiftsByEmail = async (email: string): Promise<ShiftRow[]> => {
  try {
    const { data, error } = await supabase
      .from('shifts')
      .select()
      .eq('email', email)
      .order('start_time', { ascending: true })

    if (error) throw error

    return data
  } catch (error) {
    throw new Error(`Network response was not ok: ${error}`)
  }
}

// Function to fetch shifts within the current day using Luxon
export const fetchShiftsBetween = async (
  startTimeIso: string,
  endTimeIso: string
): Promise<ShiftRow[]> => {
  try {
    const response = await axios.get(await getPublicShiftStatusUrl(), {
      params: {
        from: startTimeIso,
        to: endTimeIso,
      },
    })

    return response.data?.data ?? []
  } catch (error) {
    console.error('Error fetching public shift statuses', error)
  }

  const { data, error } = await supabase
    .from('shifts')
    .select('*')
    .gte('start_time_iso', startTimeIso)
    .lte('start_time_iso', endTimeIso)

  if (error) {
    console.error('Error fetching shifts from Supabase fallback', error)
    return []
  }

  return data
}
